import Paper from "@material-ui/core/Paper";
import trialExpired from "Assets/Svg/trial-expired-img.svg";
import React from "react";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";

class TrialExpiredPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { SubscriptionData } = this.props.SubscriptionInfo;
    //initial check if merchant's subscription and trialexpired is expired if not then push them back to login
    if (
      SubscriptionData &&
      (SubscriptionData.statusid === 4 || SubscriptionData.statusid === 7)
    ) {
      this.props.history.push("/trialexpired");
    } else if (
      SubscriptionData &&
      (SubscriptionData.statusid == 5 ||
        SubscriptionData.statusid == 6 ||
        SubscriptionData.statusid == 8)
    ) {
      this.props.history.push("/subscriptionexpired");
    } else {
      this.props.history.push("/");
    }
  }

  render() {
    return (
      <Grid
        container
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Grid item sm={12} md={4}>
          <Paper className="rounded-rectangle-paper padding24 text-center">
            <p
              className="large-text-dark-secondary t-bold margin-bottom-12"
              style={{ color: "#000", fontSize: 25 }}
            >
              Trial expired!
            </p>
            <p
              className="small-dark-secondary  margin-bottom-24"
              style={{ color: "#000" }}
            >
              Time to upgrade and come onboard
            </p>
            <img src={trialExpired} className="margin-bottom-32"></img>
            <p
              className="normal-dark-secondary margin-bottom-12"
              style={{ color: "#000" }}
            >
              Reach out to our team at
            </p>
            <p
              className="normal-dark-secondary margin-bottom-12"
              style={{ color: "#1e8ced", fontSize: 19 }}
            >
              buzz@sumhr.com
            </p>
            <p className="normal-dark-secondary" style={{ color: "#000" }}>
              and continue your journey with sumHR
            </p>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    SubscriptionInfo: state.SubscriptionInfo,
  };
};

export default connect(mapStateToProps, null)(TrialExpiredPage);
